import Layout from '../components/Layout';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { toast } from '../hooks/use-toast';
import { LogIn, ArrowRight } from 'lucide-react';

export default function LoginPage() {
  const [form, setForm] = useState({ identifier: '', password: '' });
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = new URLSearchParams(location.search).get('redirect') || '/dashboard';

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login({ identifier: form.identifier, password: form.password, role: 'customer' });
      toast({ title: `Welcome back, ${u.name}!` });
      navigate(redirect);
    } catch (err) {
      toast({ title: 'Login failed', description: err.response?.data?.detail || 'Check your credentials.' });
    } finally { setBusy(false); }
  };

  return (
    <Layout>
      <section className="py-16">
        <div className="max-w-md mx-auto px-6">
          <div className="card-soft p-8">
            <div className="w-12 h-12 rounded-xl bg-navy text-white flex items-center justify-center mb-5"><LogIn size={20} /></div>
            <h1 className="h-display text-3xl">Welcome back</h1>
            <p className="text-sm text-neutral-500 mt-1">Log in to manage your tags and vehicles.</p>

            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="text-xs font-medium">Phone or Email</label>
                <input value={form.identifier} onChange={(e) => setForm({ ...form, identifier: e.target.value })} className="mt-1 w-full px-3 py-2.5 rounded-lg border border-black/15 focus:ring-2 focus:ring-navy/30 focus:outline-none" placeholder="9876543210 or you@email.com" />
              </div>
              <div>
                <label className="text-xs font-medium">Password</label>
                <input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1 w-full px-3 py-2.5 rounded-lg border border-black/15 focus:ring-2 focus:ring-navy/30 focus:outline-none" />
              </div>
              <button disabled={busy} type="submit" className="btn-primary w-full justify-center disabled:opacity-60">{busy ? 'Logging in...' : 'Login'} <ArrowRight size={16} /></button>
            </form>

            <p className="mt-6 text-sm text-center text-neutral-600">
              New here? <Link to="/signup" className="text-navy font-semibold">Create an account</Link>
            </p>
            <p className="mt-2 text-xs text-center text-neutral-500">
              Are you a partner? <Link to="/partner/login" className="underline">Partner login</Link>
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
